<template>
	<div data-test-id="product-group-container">
		<CRow>
			<CCol>
				<h4 class="my-4">
					Insurance
				</h4>
				<ProductRelated
					:products="appleCare"
					data-test-id="apple-care"
					description="Add Insurance SKU for this product."
					modal-title="Add Insurance SKU"
					:form-type="FORM_TYPE.insurance"
					is-draggable
					@update:products="(value) => $emit('update:appleCare', value)"
					@onDragged="(newList) => $emit('update:appleCare', newList)"
				/>
				<hr class="mb-4">
			</CCol>
		</CRow>
	</div>
</template>

<script>
import ProductRelated from '@/components/ProductRelated.vue';
import { FORM_TYPE } from '../enums/modalSku';

export default {
	name: 'ProductEditAppleCare',
	components: {
		ProductRelated,
	},
	props: {
		appleCare: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			FORM_TYPE,
		};
	},
};
</script>
